import {Component, Input} from "@angular/core";
import {AbstractBackendAutocomplete} from "./abstract-backend-autocomplete";
import {ResourceRequestOverviewDTO} from "../../../core/models/resource-request";
import {Observable} from "rxjs";
import {ResourceRequestListService} from "../../../feature/resource-request-list/services/resource-request-list.service";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatAutocomplete, MatOption} from "@angular/material/autocomplete";
import {NgClass, AsyncPipe} from "@angular/common";
import {MatPseudoCheckbox} from "@angular/material/core";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
	selector: "resource-request-autocomplete",
	templateUrl: "./autocomplete.component.html",
	styleUrls: ["./autocomplete.component.scss"],
	imports: [MatProgressBar, MatAutocomplete, MatOption, NgClass, MatPseudoCheckbox, AsyncPipe, TranslatePipe],
})
export class ResourceRequestAutocompleteComponent extends AbstractBackendAutocomplete<ResourceRequestOverviewDTO> {
	@Input() multiSelect: boolean = false;

	constructor(private _resourceRequestService: ResourceRequestListService) {
		super();
	}

	displayAsSelectedOption(element: ResourceRequestOverviewDTO): string {
		if (element.client) {
			return element.client + " " + element.requestTitle;
		} else {
			return element.requestTitle;
		}
	}

	getElementsFromBackendForSearchTerm(searchTerm: string): Observable<ResourceRequestOverviewDTO[]> {
		return this._resourceRequestService.findResourceRequestBySearchTerm(searchTerm);
	}

	sort(element: ResourceRequestOverviewDTO, otherElement: ResourceRequestOverviewDTO): number {
		return element.requestTitle.toLowerCase().localeCompare(otherElement.requestTitle.toLowerCase());
	}
}
